import * as i0 from "@angular/core";
export class UploaderModule {
    static ɵfac = function UploaderModule_Factory(t) { return new (t || UploaderModule)(); };
    static ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: UploaderModule });
    static ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
}
